export const roundToNearestCent = (amount) => {
  return (Math.round((amount + Number.EPSILON) * 100) / 100);
};

export const convertCentsToDollar = (amount) => {
  const dollarAmount = parseInt(amount, 10) / 100;
  return roundToNearestCent(dollarAmount);
};
